import { Reducer } from 'redux';
import { IModalStore } from './type';
import { TypesModals } from 'redux/actions/modals/type';

const modalState: IModalStore = {
  openIdWPModal:null,
  openDocumentModal:null
};

export const modals: Reducer<IModalStore> = (
  state = modalState,
  action
) => {
  switch (action.type) {
    case TypesModals.OPEN_WP_MODAL:
      return {
        ...state,
        openIdWPModal: action.data
      };
    case TypesModals.CLOSE_WP_MODAL:
      return {
        ...state,
        openIdWPModal: null
      };
    default:
      return state;
  }
};
